import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { FacadeService } from 'src/app/shared/service/facade/facade.service';
import { DimonaAdmin } from '../../model/dimonaAdmin.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DimonaDialogComponent } from 'src/app/shared/component/admin-dialog/dimona-dialog/dimona-dialog.component';

@Component({
  selector: 'app-dimona',
  templateUrl: './dimona.component.html',
  styleUrls: ['./dimona.component.css']
})
export class DimonaComponent implements OnInit {
  @ViewChild('DimonaPaginator', { static: true }) paginator: MatPaginator;

  form: FormGroup;

  dimona: DimonaAdmin;

  dataSource: DimonaAdmin[];

  constructor(
      private facadeService: FacadeService,
      private dialog: MatDialog,
      private fb: FormBuilder
    ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      contractId: ['', Validators.required]
    });
  }

  displayedColumns: string[] = [
    "dimonaType",
    "dimonaStatus",
    "startDate",
    "endDate",
    "dimonaPerdiodId",
    "dimonaInReference"
  ];

  loadDimona() {
    if (this.form.value.contractId !== null && this.form.value.contractId !== '' && this.form.value.contractId !== undefined) {
      this.facadeService.getDimonaAdminForContract(this.form.value.contractId).subscribe(
        (data: DimonaAdmin[]) => {
          this.dataSource = data;
        }
      );
    }
  }

  openPopUp(row) {
    const dialogRef = this.dialog.open(DimonaDialogComponent, {
      data: { element: row },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadDimona();
    });
  }

}
